import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.match.js";
import { defineComponent, onMounted, ref } from 'vue';
import { getUserData, getUserData1, updateOrganizationNew } from '@/service/communication/personalDetail';
import { useEmptyStringFormat } from '@/hooks/fn';
import { Toast } from 'vant';
import { useRoute } from 'vue-router';
import localCache from '@/utils/localCache';
export default defineComponent({
  name: 'PersonalDetail',
  components: {},
  setup: function setup(props, ctx) {
    var emptyStringFormat = useEmptyStringFormat();
    var route = useRoute();
    var param = ref({
      mobile: '',
      user_id: ''
    });
    if (route.query.user_id) {
      localCache.setItem('user_id', route.query.user_id);
    }
    if (route.query.mobile) {
      localCache.setItem('mobile', route.query.mobile);
    }
    var user_id = localCache.getItem('user_id');
    var mobile = localCache.getItem('mobile');
    if (user_id) {
      param.value.user_id = user_id;
    }
    if (mobile) {
      param.value.mobile = mobile;
    }
    var data = ref({
      company: '',
      id: 0,
      mobile: '',
      monthCount: '',
      monthMoney: '',
      name: '',
      responsibility: '',
      user_name: '',
      yearCount: '',
      yearMoney: ''
    });
    var data1 = ref({
      absentFromWork: 0,
      beLate: 0,
      leaveDays: 0,
      noSign: 0,
      realWorkDays: 0,
      workDays: 0
      // absentFromWork: '-',
      // beLate: '-',
      // leaveDays: '-',
      // noSign: '-',
      // realWorkDays: '-',
      // workDays: '-'
    });
    var responsibility = ref('');
    var status = ref(true);
    var toWrite = function toWrite() {
      status.value = false;
    };
    var getUserInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserData({
                mobile: param.value.mobile
              });
            case 2:
              res = _context.sent;
              data.value = res.data;
              responsibility.value = data.value.responsibility;
              if (res.data.responsibility) {
                status.value = true;
              } else {
                status.value = false;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getUserInfo() {
        return _ref.apply(this, arguments);
      };
    }();
    var getUserAttendanceInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getUserData1({
                userId: param.value.user_id
              });
            case 2:
              res = _context2.sent;
              data1.value = res.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getUserAttendanceInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    var updateOrganizationNewAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (responsibility.value) {
                _context3.next = 3;
                break;
              }
              Toast('工作职责不能为空');
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return updateOrganizationNew({
                id: String(data.value.id),
                responsibility: responsibility.value
              });
            case 5:
              res = _context3.sent;
              Toast(res.data);
              getUserInfo();
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function updateOrganizationNewAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    var test = function test() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        window.test1(param.value.mobile);
      }
      if (isIOS) {
        window.test(param.value.mobile);
      }
    };
    onMounted(function () {
      getUserInfo();
      getUserAttendanceInfo();
    });
    return {
      param: param,
      data: data,
      data1: data1,
      test: test,
      emptyStringFormat: emptyStringFormat,
      responsibility: responsibility,
      updateOrganizationNewAsync: updateOrganizationNewAsync,
      toWrite: toWrite,
      status: status
    };
  }
});